import { combineReducers } from "@reduxjs/toolkit";

import {
	accountsCarParksDataModalState,
	accountsCarParksDataModalReducer,
	accountsCarParksDataModalAction,
} from "./dataModal";

export type StateCarParks = {
	dataModal: accountsCarParksDataModalState;
};

export const carParks = combineReducers<StateCarParks>({
	dataModal: accountsCarParksDataModalReducer,
});

export const accountsCarParksAction = {
	dataModal: accountsCarParksDataModalAction,
};

export default carParks;
